export default __webpack_public_path__ + "static/media/listadoPS.d72116e4.svg";